import ModernTechnologies from './ModernTechnologies'

export default ModernTechnologies;